import { produce } from "immer"
import { HxMapGroup } from "../../../../Comps/HxMap/HxMapGroup"
import { HexMap } from "../../../../Data/HexMap/HexMap"
import { HexMapBuilderParams, BuildHexMap } from "../../../../Data/HexMap/HexMapBuilder"
import { HexMapModifier } from "../../../../Data/HexMap/HexMapModifier"
import { Key } from "../../../../Data/HexMap/Key"
import { All } from "../../../../Util/Constants/Quantities"
import { Music } from "../../../../Util/Music/Music"
import { TransformTranslate } from "../../../../Util/Transform/Transform"
import { useState } from "react"

export function CycleOfThirdsMap(){
    const activeCols:number[][][] = [
        [[0,7,15],[22,30,37]],
        [[1,8,16],[23,31,38]],
        [[2,9,17],[24,32,39]],
        [[3,10,18],[25,33,40]]
    ]
    const onKeyClick = (key:Key) => {
        const keyIndex:number = key.params.keyIndex
        const matchedRow:number[][]|undefined = activeCols.find((row:number[][])=>{
            return (row[0].includes(keyIndex) || row[1].includes(keyIndex))
        })
        if(matchedRow !== undefined){
            setMap(produce((draft:HexMap)=>{
                const mod:HexMapModifier = new HexMapModifier(draft)
                mod.keys_setDefault([All])
                mod.keys_setHilited(matchedRow[0])
                mod.keys_setSelected(matchedRow[1])
            })) 
        }
    }
    const getMap = () => {
        const params:HexMapBuilderParams = {rows:6, columns:7, tonic:Music.G, radius:40}
        const map:HexMap = BuildHexMap(params)
        const mod:HexMapModifier = new HexMapModifier(map)
        mod.keys_setOpen([All], false)
        mod.keys_setVisible([14,21,28,29,35,36,5,6,12,13,20,27], false)
        mod.keys_setHilited(activeCols[0][0])
        mod.keys_setSelected(activeCols[0][1])
        //mod.keys_setPositionAsLabel([All])
        return map
    }
    const [map, setMap] = useState<HexMap>(getMap())
    const [width,height] = [650,600]
    return(
        <div>
            <svg width={width} height={height}>
                <g transform={TransformTranslate(width/2, height/2)}>
                    <HxMapGroup hexMap={map} onKeyClick={onKeyClick}/>
                </g>
            </svg>
        </div>
    )
}